import { axiosEjFetch } from "./axiosEjHelpers";
import axios from "axios";
import { getAppConfiguration } from "appConfig";
import { getSession } from "next-auth/react";

export interface QuickPaymentRequest {
  amount: number;
  numberOfPhotos: number;
  includeVideo?: boolean;
  currencyCode?: string;
  firstName: string;
  lastName: string;
  email: string;
  name: string;  // billing name
  address: string;
  city: string;
  zip: string;
  countryCode: string;
  successUrl: string;
  cancelUrl: string;
  languageCode: string;
  photoSessionId?: string;
  password?: string;
}

export interface QuickPaymentDefaults {
  isLoggedIn: boolean;
  firstName: string;
  lastName: string;
  email: string;
  name: string;
  address: string;
  city: string;
  zip: string;
  countryCode: string;
}

export interface QuickPaymentPricing {
  qpPhotoCost: number | null;
  qpVideoCost: number | null;
  currencyCode: string;
  found: boolean;
}

export async function startQuickPayment(request: QuickPaymentRequest) {
  return axiosEjFetch.post("/api/quickpayment/start", request);
}

export async function getQuickPaymentDefaults(): Promise<QuickPaymentDefaults> {
  const appConfiguration = await getAppConfiguration();
  const url = `${appConfiguration.apiUrl}/api/quickpayment/defaults`;

  // Opcionálisan csatolunk tokent — ha van session, elküldjük, ha nincs, token nélkül hívjuk
  const session: any = await getSession();
  const headers: Record<string, string> = {};
  if (session?.accessToken) {
    headers["Authorization"] = `Bearer ${session.accessToken}`;
  }

  const response = await axios.get<QuickPaymentDefaults>(url, { headers });
  return response.data;
}

export async function getQuickPaymentPricing(
  countryCode?: string,
  sessionId?: string
): Promise<QuickPaymentPricing> {
  const appConfiguration = await getAppConfiguration();
  const params = new URLSearchParams();
  if (countryCode) params.set("countryCode", countryCode);
  if (sessionId) params.set("sessionId", sessionId);

  const url = `${appConfiguration.apiUrl}/api/quickpayment/pricing?${params.toString()}`;

  const session: any = await getSession();
  const headers: Record<string, string> = {};
  if (session?.accessToken) {
    headers["Authorization"] = `Bearer ${session.accessToken}`;
  }

  const response = await axios.get<QuickPaymentPricing>(url, { headers });
  return response.data;
}